import { Mfa_Status, isGqlError, pollMfaByAppStatus } from '@chegg/one-auth-sdk';
import { handleGeneralError } from "./error";
import { handleSent } from "./sent";
import { qrSlice } from "../../slices/qr";
import { routerSlice } from "../../slices/router";
import { handleToastMessage } from "../utils/orchestrator.utils";
export { handleOnboarding };
async function handleOnboarding(getState, dispatch, response) {
  dispatch(qrSlice.actions.setQRLink(response.qrLink));
  dispatch(routerSlice.actions.changeRoute('qr'));
  try {
    var _getState$authParams = getState().authParams,
      cheggMfaToken = _getState$authParams.cheggMfaToken,
      uuid = _getState$authParams.uuid;
    var mfaStatusResponse = await pollMfaByAppStatus({
      mfaToken: cheggMfaToken,
      userUuid: uuid,
      flow: 'onboarding',
      pollingOptions: getTimeout()
    });
    switch (mfaStatusResponse.status) {
      case Mfa_Status.SENT:
        await handleSent(getState, dispatch);
        break;
      case Mfa_Status.OS_DECLINED_PUSH:
        dispatch(routerSlice.actions.changeRoute('os_push_declined'));
        break;
      case Mfa_Status.BLOCKED:
        handleToastMessage(dispatch, 'blocked');
        break;
      case Mfa_Status.EXPIRED:
        handleToastMessage(dispatch, 'qr_session_expired');
        break;
      default:
        handleGeneralError(dispatch);
        break;
    }
  } catch (e) {
    var error = e;
    if (isGqlError(error) && error.code === 'polling_timeout') {
      handleToastMessage(dispatch, 'qr_session_expired');
    } else {
      handleGeneralError(dispatch);
    }
  }
}

/* istanbul ignore next this is only used by testcafe */
function getTimeout() {
  var _window;
  var shortTimeout = ((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.search.indexOf('MFA_DIALOG_TIMEOUT_TEST')) > -1;
  return {
    timeoutDuration: shortTimeout ? 2000 : undefined,
    pollingInterval: shortTimeout ? undefined : 3000
  };
}